import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

import { urlUtility } from "@repo/utilities/url.utility.ts";
export const useGetAllOccupationsService = ({
  enableQuery = true,
  page = "1",
  per_page = "15",
  isParent = true,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const parentId = +urlQueries?.["parent-id"] || "";
  const created_between = urlQueries["created_between"] || "";

  const allOccupationsService = useQuery({
    queryKey: [
      ...CACHE_KEYS.OCCUPATIONS,
      page,
      debouncedQuery,
      per_page,
      parentId,
      isParent,
      created_between,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.OCCUPATIONS,
        searchParams: {
          "filter[name]": debouncedQuery,
          ...(isParent && { "filter[parent_id]": parentId }),
          "filter[created_between]": created_between,
          include: "parent",
          page,
          per_page,
        },
      }),
    enabled: enableQuery,
  });
  return {
    services: { allOccupationsService },
    states: { searchQuery, setSearchQuery },
  };
};
